import { atom } from "recoil";

// 추가 복지포인트 이력 전역 상태
// 엔트리 스키마 예시:
// {
//   id: string,
//   mem_no: number,
//   mem_name: string,
//   mem_team: string | number,
//   mem_rank: string | number,
//   imageUrl: string,
//   amount: number,           // 지급 금액(원)
//   months: number,           // 분할 지급 개월 (0 = 일시 지급)
//   reason: string,           // 사유
//   applyDate: string|null,   // 적용 시점(YYYY-MM-DD) | null(즉시)
//   createdAt: string         // 생성 시각 ISO 문자열
// }
export const wpAdditionalHistory = atom({
  key: "wpAdditionalHistory",
  default: [],
});

export default wpAdditionalHistory;
